import Gallery from "../../../../../src/gallery/Gallery.tsx";
import * as React from 'react';
export default {
  Gallery,
  React
};